import gql from 'graphql-tag';

// Fragment selecting only the ids of a child list, e.g. Article.sections
const childListFragment = (parentType, field) => gql`
  fragment ${parentType}_${field} on ${parentType} {
    id
    ${field} {
      id
    }
  }
`;

const updateChildList = (cache, { parentType, parentId, field }, update) => {
  const id = `${parentType}:${parentId}`;
  const fragment = childListFragment(parentType, field);

  try {
    const parent = cache.readFragment({ id, fragment });
    if (!parent) return;

    cache.writeFragment({
      id,
      fragment,
      data: {
        ...parent,
        [field]: update(parent[field])
      }
    });
  } catch (e) {
    // parent is not in the cache, nothing to update
  }
};

// Adds a newly created item to a list field on its parent object in the cache.
// The item itself is already normalized into the cache from the mutation result.
const addToChildList = (cache, parent, item) =>
  updateChildList(cache, parent, list => [...list, item]);

const removeFromChildList = (cache, parent, itemId) =>
  updateChildList(cache, parent, list => list.filter(item => item.id !== itemId));

// Updates the edges of a paginated root query, e.g. encyclopedia
const updateQueryEdges = (cache, { query, variables, field }, update) => {
  try {
    const data = cache.readQuery({ query, variables });

    cache.writeQuery({
      query,
      variables,
      data: {
        ...data,
        [field]: {
          ...data[field],
          edges: update(data[field].edges)
        }
      }
    });
  } catch (e) {
    // query is not in the cache, nothing to update
  }
};

// Returns true if any item, or any nested child item, is unpublished
const hasUnpublishedContent = (items, childFields) => {
  const [childField, ...restFields] = childFields;

  return items.some(item =>
    !item.availability.published ||
    (childField && hasUnpublishedContent(item[childField] || [], restFields))
  );
};

export {
  addToChildList,
  removeFromChildList,
  updateQueryEdges,
  hasUnpublishedContent
};
